import { render, staticRenderFns } from "./EnvelopeTable.vue?vue&type=template&id=4265f7fa"
import script from "./EnvelopeTable.vue?vue&type=script&lang=js"
export * from "./EnvelopeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports